<template>
  <div style="background: #f2f2f2" data-app>
    <v-overlay :value="overlay"></v-overlay>
    <div class="login-otp-wrapper">
      <div class="login-otp">
        <div style="text-align: center">
          <p style="font-size: 12px; font-weight: 400">
            {{ is_vgs == 1 ? $t("notiSendOtp") : $t("notiSendOtpVGS") }}
          </p>
          <br />
          <p style="font-weight: bold">
            {{ $t("subSendOtp") }}
          </p>
        </div>
        <div class="wrapper-otp-login">
          <v-otp-input
            :disabled="loading"
            length="6"
            @finish="onFinish"
            pattern="\d*"
          ></v-otp-input>
        </div>
      </div>
    </div>
    <v-dialog
      v-model="dialogConfirmOTP"
      hide-overlay
      persistent
      width="300"
      style="background: #ffffff"
    >
      <v-card color="red" style="background: palegreen">
        <v-card-text class="text-center">
          {{ $t("waitOtpText") }}...
          <v-progress-linear
            indeterminate
            color="#fff"
            background-color="#000"
            class="mb-0"
            :active="true"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { verifyOtpLogin } from "@/views/api/wap/user";
import { generateSignatureOtherService } from "@/utils/signature";

export default {
  name: "WapLoginOtp",
  data() {
    return {
      dialogConfirmOTP: false,
      loading: false,
      overlay: false,
      phone: null,
      cif: null,
      is_vgs: null
    };
  },
  created() {
    let phone = this.$router.history.current.query.phone;
    let cif = this.$router.history.current.query.cif;
    let is_vgs = this.$router.history.current.query?.type;
    if (
      phone === undefined ||
      phone.length === 0 ||
      cif === undefined ||
      cif.length === 0
    ) {
      this.$message.error("Thông tin không hợp lệ!");
      this.overlay = true;
    } else {
      this.phone = phone;
      this.cif = cif;
      this.is_vgs = is_vgs;
    }
  },
  watch: {
    dialog(val) {
      if (!val) return;
      setTimeout(() => (this.dialogConfirmOTP = false), 4000);
    }
  },
  methods: {
    async onFinish(otp) {
      this.dialogConfirmOTP = true;
      this.loading = true;
      this.overlay = true;

      let data = {
        phone: this.phone,
        code: Number(otp),
        cif: this.cif
      };

      data.signdata = generateSignatureOtherService(data);

      await verifyOtpLogin(data).then(res => {
        console.log("res........", res);
        if (res.error_code === 0) {
          let token = res.data.token;
          let url = window.location.host + "/navigate?token=" + token;
          console.log("url........", url);
          this.$router.push("/navigate?token=" + token);
        } else {
          this.$message.error("Mã OTP không chính xác. Vui lòng thử lại!");
        }

        this.dialogConfirmOTP = false;
        this.loading = false;
        this.overlay = false;
      });
    }
  }
};
</script>

<style>
.login-otp-wrapper {
  padding: 20px;
  height: 100vh;
  max-width: 500px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.otp-field-box--0,
.otp-field-box--1,
.otp-field-box--2,
.otp-field-box--3,
.otp-field-box--4,
.otp-field-box--5 {
  font-weight: bold !important;
}

.wrapper-otp-login {
  max-width: 300px;
  align-content: center;
  margin: 0 auto;
}
</style>
